import { useEffect } from "react";
import { InviteContext } from "@/components/invite/InviteContext";
import { InviteForm } from "@/components/invite/InviteForm";
import { InviteProtocolSection } from "@/components/invite/InviteProtocolSection";
import { FeedbackComparison } from "@/components/feedback/FeedbackComparison";
import { FeedbackProcess } from "@/components/feedback/FeedbackProcess";
import { FeedbackStory } from "@/components/feedback/FeedbackStory";
import { FeedbackFounders } from "@/components/feedback/FeedbackFounders";
import { SampleFormula } from "@/components/sample/SampleFormula";
import "@/components/sample/sample.css";
import { PrivacyFooter } from "@/components/privacy/PrivacyFooter";

export default function Invite() {
  useEffect(() => {
    const title = document.title;
    document.title = "Your Invitation to Try Vitura";
    const changes = [
      ["description", "A personal invitation to try Vitura. Request your five-day Cucumber Melon sample kit."],
      ["robots", "noindex, nofollow"],
    ].map(([name, content]) => {
      const existing = document.querySelector(`meta[name="${name}"]`);
      const node = existing || document.createElement("meta");
      const previous = node.getAttribute("content");
      node.setAttribute("name", name);
      node.setAttribute("content", content);
      if (!existing) document.head.appendChild(node);
      return () => {
        if (!existing) node.remove();
        else if (previous === null) node.removeAttribute("content");
        else node.setAttribute("content", previous);
      };
    });
    return () => { document.title = title; changes.forEach(restore => restore()); };
  }, []);
  return (
    <main className="sample-experience min-h-screen bg-[#faf9f5]" data-testid="invite-page">
      <div className="grid grid-cols-1 lg:grid-cols-2" data-testid="invite-top-section">
        <InviteContext /><InviteForm />
      </div>
      <InviteProtocolSection />
      <FeedbackComparison />
      <FeedbackProcess />
      <FeedbackStory />
      <FeedbackFounders />
      <SampleFormula />
      <PrivacyFooter prefix="invite" />
    </main>
  );
}